
// tslint:disable:no-bitwise

function generateUuidPart(length: number): string {
    let str = '';

    while (str.length < length) {
        let num = Math.random() * 16;
        num = num | 0; // clear decimal
        str += num.toString(16);
    }

    return str;
}

export const Empty = '00000000-0000-0000-0000-000000000000';

/**
 * Return a v4 UUID as specified by RFC 4122 http://tools.ietf.org/html/rfc4122
 *
 * @public
 */
export function generate(): string {

    const parts: string[] = [];
    parts.push(generateUuidPart(8));
    parts.push(generateUuidPart(4));

    // first digit must be 4 since we are using pseudorandom numbers
    const timeHighAndVersion = '4' + generateUuidPart(3);
    parts.push(timeHighAndVersion);

    // first digit must have first two bits set to 10
    let clockSeqHiAndReserved = generateUuidPart(4);
    // ClockSeqHiAndReserved is a base-16 string.
    let intVal = parseInt(clockSeqHiAndReserved[0], 16);
    intVal = intVal & 3; // clear out first two bits
    intVal = intVal | 8; // set first bit to 1
    clockSeqHiAndReserved = intVal.toString(16) + clockSeqHiAndReserved.substr(1);
    parts.push(clockSeqHiAndReserved);

    parts.push(generateUuidPart(12));
    return parts.join('-');
}

/**
 * Normalizes a GUID to lowercase. Returns '' if guid is not given.
 * @param includeBrackets - if true, add or keep brackets; if false, strip brackets
 *
 * @public
 */
export function normalizeLower(guid: string | null | undefined, includeBrackets: boolean = false): string {
    return guid ? _normalizeBrackets(guid.toLowerCase(), includeBrackets) : '';
}

/**
 * Normalizes a GUID to uppercase. Returns '' if guid is not given.
 * @param includeBrackets - if true, add or keep brackets; if false, strip brackets
 *
 * @public
 */
export function normalizeUpper(guid: string | null | undefined, includeBrackets: boolean = false): string {
    return guid ? _normalizeBrackets(guid.toUpperCase(), includeBrackets) : '';
}

/**
 * Normalizes the dashes in a GUID. Returns '' if the input is null, undefined, or does not contain
 * 32 hexadecimal characters.
 * @param guid - The GUID
 * @param includeBrackets - if true, output will contain brackets; if false, output will not
 *
 * @public
 */
export function normalizeDashes(guid: string | null | undefined, includeBrackets: boolean = false): string {
    if (guid) {
        const parsed = guid.replace(/[^A-Fa-f0-9]/g, '');
        if (parsed.length === 32) {
            return _normalizeBrackets(`${
                parsed.slice(0, 8)
                }-${
                parsed.slice(8, 12)
                }-${
                parsed.slice(12, 16)
                }-${
                parsed.slice(16, 20)
                }-${
                parsed.slice(20)
                }`, includeBrackets);
        }
    }

    return '';
}

function _normalizeBrackets(guid: string, includeBrackets: boolean): string {
    let match = guid.match(/^\{(.*)\}$/);
    if (match) {
        return includeBrackets ? match[0] : match[1];
    }
    return includeBrackets ? '{' + guid + '}' : guid;
}
